import FeedbackForm from "../components/Feedback/FeedbackForm";
import FeedbackList from "../components/Feedback/FeedbackResponses";
import Footer from "../components/common/Footer";
import Navbar from "../components/common/Navbar";

import "../assets/css/feedbackPage.css";

function FeedbackPage() {

    return (

        <section className="customer-feedback-page">

            <Navbar />

            {/*=========================================================
                            HERO SECTION
            =========================================================*/}

           <section className="customer-feedback-hero">

    <div className="customer-feedback-hero-content">

        <span className="customer-feedback-badge">
            STORY LINE STUDIOS
        </span>

        <h1>Client Feedback</h1>

        <div className="customer-feedback-line"></div>

        <p>
            Discover heartfelt words from our wonderful clients who trusted
            Story Line Studios to capture their unforgettable moments with
            timeless elegance, cinematic storytelling, and exceptional quality.
        </p>

    </div>

</section>
            {/*=========================================================
                            CONTENT
            =========================================================*/}

            <section className="customer-feedback-container">

                <div className="customer-feedback-form-wrapper">

                    <FeedbackForm />

                </div>

                <div className="customer-feedback-list-wrapper">

                    <FeedbackList />

                </div>

            </section>

            <Footer />

        </section>

    );

}

export default FeedbackPage;